import { render, staticRenderFns } from "./AddExamPage.vue?vue&type=template&id=72afe696&"
import script from "./AddExamPage.vue?vue&type=script&lang=js&"
export * from "./AddExamPage.vue?vue&type=script&lang=js&"
import style0 from "./AddExamPage.vue?vue&type=style&index=0&id=72afe696&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports